import { useLingui } from "@lingui/react";
import { CheckCircle, Plus } from "lucide-react";
import { Button } from "@/components/ui/button";
import type { ActiveTabsIds } from "./tabs/types";
import { getAddLabel, getSectionTitle } from "./tabs/tab-utils";

export function RecipesSectionHeader({
  activeTab,
  onSelectClick,
  isSelecting = false,
  onAddClick,
  showAdd = true,
}: {
  activeTab: ActiveTabsIds;
  onSelectClick?: () => void;
  isSelecting?: boolean;
  onAddClick?: () => void;
  /** False hides the Add button, e.g. recipes in Working mode (YC-33). */
  showAdd?: boolean;
}) {
  const { i18n } = useLingui();

  return (
    <div className="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
      <div className="flex items-center gap-3">
        <h2 className="text-3xl font-semibold text-(--color-text-primary)">
          {getSectionTitle(activeTab, i18n)}
        </h2>
      </div>
      <div className="flex items-center gap-2">
        <Button
          variant={isSelecting ? "default" : "outline"}
          className="h-10 gap-2 rounded-lg"
          onClick={onSelectClick}
        >
          <CheckCircle className="size-4" />
          {isSelecting ? i18n._("Cancel") : i18n._("Select")}
        </Button>
        {showAdd && (
          <Button className="h-10 gap-2 rounded-lg" onClick={onAddClick}>
            <Plus className="size-4" />
            {getAddLabel(activeTab, i18n)}
          </Button>
        )}
      </div>
    </div>
  );
}
